import { useEffect, useState } from "react";
import axios, { AxiosError } from "axios";
import { drawalReason } from "./TestData";
import BtnsModal from "../components/BtnsModal";
import Modal from "../components/Modal";
import ApiUrl from "../config/app-config";

const baseURL = ApiUrl();
const pageName = "탈퇴하기";

const WithDrawalPage = (props) => {
  const headerUi = {
    goback: false,
    closeAll: true,
  };

  useEffect(() => {
    props.onPageName(pageName);
    props.onHeaderUi(headerUi);
  }, []);

  /**정보 보존 기간 동의 체크 여부 */
  const [check, setCheck] = useState(false);
  const onCheck = () => {
    if (check !== true) {
      setCheck(true);
    } else {
      setCheck(false);
    }
  };

  /**탈퇴 사유 */
  const [drawReason, setDrawReason] = useState(null);
  const [radioAction, setRadioAction] = useState(null);
  const [reasonEtc, setReasonEtc] = useState(null);

  const onReasonHandler = (e) => {
    const reason = e.target.value;
    if (reason !== "기타") {
      setDrawReason(String(reason));
      setRadioAction(String(reason));
    } else {
      setRadioAction(String(reason));
    }
  };

  useEffect(() => {
    if (radioAction === "기타") {
      setDrawReason(String(reasonEtc));
      document.getElementById("etc_reason").focus();
      document.getElementById("draw5").addEventListener("click", function () {
        document.getElementById("etc_reason").focus();
      });
    }
  }, [reasonEtc, radioAction, drawReason]);

  /**환불 데이터 받아오기 및 환불 건수 구하기*/
  const [refundData, setRefundData] = useState(0);
  const users = sessionStorage.getItem("userId");
  const userId = Number(users);

  /**탈퇴 예정 회원 잔여 정산 건 조회(보유 페이백, 패널티 금액)*/
  const [totalPayback, setTotalPayback] = useState(0);
  const [paybackPrice, setPaybackPrice] = useState();
  const [totalPenalty, setTotalPenalty] = useState(0);
  const [penaltyPrice, setPenaltyPrice] = useState();
  const [deduction, setDeduction] = useState();

  async function getPenaltyData() {
    props.onIsLoading(true);

    try {
      const response = await axios.get(`${baseURL}/user/withdrawal/${userId}`);
      const success = response.data;
      const result = success.summary;
      props.onIsLoading(false);
      setTotalPenalty(
        result !== null && result.totalPenalty !== null
          ? result.totalPenalty
          : 0
      );
      setTotalPayback(
        result !== null && result.totalPayback !== null
          ? result.totalPayback
          : 0
      );
      setRefundData(
        result !== null && result.refundCount !== null ? result.refundCount : 0
      );
      setDeduction(
        success !== null && success.allowWithdrawal !== null
          ? success.allowWithdrawal
          : false
      );
      props.onIsLoading(false);
    } catch (error) {
      props.onIsLoading(false);
      props.onError(true);
      console.error(error);
    }
  }

  useEffect(() => {
    if (users) {
      if (userId !== 0) {
        return getPenaltyData();
      } else if (userId === 0) {
        return props.onError(true);
      } else if (!userId) {
        return props.onError(true);
      }
    }
  }, [userId]);

  useEffect(() => {
    //변환
    const penalty =
      totalPenalty &&
      totalPenalty.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    const payback =
      totalPayback &&
      totalPayback.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    setPenaltyPrice(penalty);
    setPaybackPrice(payback);
  }, [totalPenalty, totalPayback]);

  /**라디오 모양설정 */
  useEffect(() => {
    if (check) {
      document.querySelector(".agree_btn").style.background =
        "url('./img/Circle-ckeck.svg') no-repeat";
    } else {
      document.querySelector(".agree_btn").style.background =
        "url('./img/Circle-check.svg') no-repeat";
    }
  }, [check]);

  const [isWithDrawalModal, setIsWithDrawalModal] = useState(false);
  const [isCompleteModal, setIsCompleteModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const modalOpen = () => {
    setIsWithDrawalModal(true);
  };

  const onWithDrawal = () => {
    axios
      .delete(`${baseURL}/auth/${userId}?reason=${drawReason}`)
      .then(() => {
        setIsCompleteModal(true);
      })
      .catch((error) => {
        if (axios.isAxiosError(error) && error.response) {
          const data = error.response.data;

          // 400일때 서버 메세지 출력
          if (data.status === 400) {
            setErrorMessage(data.detail);
            return;
          }
        }
        props.onError(true);
        console.error(error);
      });
  };

  /**탈퇴 완료되었습니다 확인 시 앱으로 전달 */
  const userAgent = navigator.userAgent.toLowerCase();

  const clickOk = () => {
    //안드로이드
    if (userAgent.indexOf("android") > -1) {
      window.postMessageToAndroid.movusCallBack("secession");
      return "android";
    }

    //IOS
    if (
      userAgent.indexOf("iphone") > -1 ||
      userAgent.indexOf("ipad") > -1 ||
      userAgent.indexOf("ipod") > -1
    ) {
      window.webkit.messageHandlers.movusCallBack.postMessage({
        command: "secession",
      });
      return "ios";
    }

    // 그 외
    window.postMessageToAndroid.movusCallBack("secession");
    return "other";
  };

  /**모달창 생성 시 스크롤 고정 */
  useEffect(() => {
    if (isWithDrawalModal === true) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
  }, [isWithDrawalModal]);

  return (
    <>
      <div className="container drawal_wrap">
        <div className="drawal_header">
          <h2 className="font-primary">무버스 서비스를 탈퇴하시겠습니까?</h2>
          <p className="font-content">보유 리워드와 정산 현황을 확인하세요</p>
        </div>

        <div className="drawal_content_wrap">
          <div className="total_reword drawal_content">
            <p>보유 리워드</p>
            <p>{paybackPrice} 원</p>
          </div>
          <div className="drawal_content">
            <p>주차비 접수 건</p>
            <p>{refundData} 건</p>
          </div>
          <div className="drawal_content">
            <p>내실 돈</p>
            <p>{penaltyPrice} 원</p>
          </div>
          <div className="drawal_content">
            <p>소득 공제 신고</p>
            <p>{deduction == false ? "필요" : "불필요"}</p>
          </div>
        </div>
        <div className="warning">
          <ul>
            <li>남은 리워드 및 주차비 환급 완료 후 탈퇴가 가능해요.</li>
            <li>탈퇴 요청 중에는 콜 운행이 불가해요.</li>
            <li>탈퇴 철회 요청은 고객센터로 접수해 주세요.</li>
            <li>탈퇴 시 계정이 삭제되며, 개인정보가 모두 파기돼요.</li>
            <li>
              사고 또는 분쟁 처리 중이거나 내실 돈이 있을 경우 탈퇴할 수 없어요.
            </li>
            <li>
              소득 공제 신고 필요 대상자일 경우 리워드 지급 받은 달의 다음 달
              15일 이후(소득공제신고 후)탈퇴 신청이 가능해요.
            </li>
          </ul>
        </div>
        <div className="reason font-second">
          <h3 className="font-primary">탈퇴사유를 남겨주세요</h3>
          {drawalReason &&
            drawalReason.map((draw) => {
              return (
                <div
                  className="reason_radio"
                  key={`draw${draw.id}`}
                  onChange={onReasonHandler}
                >
                  <input
                    type="radio"
                    name="out_reason"
                    id={`draw${draw.id}`}
                    value={draw.text}
                  />
                  <label htmlFor={`draw${draw.id}`}>
                    <span className="radio_btn"></span>
                    <span className="radio_txt">{draw.text}</span>
                  </label>
                </div>
              );
            })}

          <div
            className={`reason_etc_wrap ${
              radioAction === "기타" ? "etc_action" : ""
            }`}
          >
            <input
              type="text"
              className="reason_etc"
              id="etc_reason"
              placeholder="기타사유를 입력해주세요."
              onChange={(e) => setReasonEtc(e.target.value)}
            />
          </div>
        </div>
        <div className="keep_userinfo">
          <h3 className="font-primary">회원정보 보존 안내드려요</h3>
          <ul>
            <li>
              회원정보 보존 세부 내용
              <span>보존목적 : 회원 탈퇴 후 재가입 방지</span>
              <span>보존항목 : 암호화된 동일인 식별정보 (CI)</span>
              <span>보존기간 : 1개월</span>
            </li>
            <li>보존 근거 : 가입 시 동의 한 '이용약관' 제3조 제1항</li>
          </ul>
        </div>
        <div className="agree_check">
          <label htmlFor="agree">
            <span className="agree_btn"></span>
            <span className="agree_txt font-content">
              회원정보 보존 기간에 대해 동의할게요.
            </span>
          </label>
          <input type="checkbox" name="agree" id="agree" onChange={onCheck} />
        </div>
      </div>
      <div className="drawal_footer_btn">
        <button
          disabled={
            totalPayback > 0 ||
            refundData > 0 ||
            totalPenalty > 0 ||
            check !== true ||
            deduction == false ||
            drawReason === null
              ? true
              : false
          }
          className={
            totalPayback > 0 ||
            refundData > 0 ||
            totalPenalty > 0 ||
            check !== true ||
            deduction == false ||
            drawReason === null
              ? "disabled"
              : null
          }
          onClick={
            totalPayback > 0 ||
            refundData > 0 ||
            totalPenalty > 0 ||
            check !== true ||
            deduction == false ||
            drawReason === null
              ? null
              : modalOpen
          }
        >
          탈퇴하기
        </button>
      </div>
      {isWithDrawalModal && (
        <BtnsModal
          closeModal={() => {
            setIsWithDrawalModal(false);
          }}
          onOk={onWithDrawal}
        >
          <h3>탈퇴하시겠습니까?</h3>
        </BtnsModal>
      )}
      {isCompleteModal && (
        <Modal closeModal={clickOk}>
          <h5 className="success_title drawal_title">탈퇴 완료되었습니다.</h5>
        </Modal>
      )}
      {errorMessage && (
        <Modal closeModal={() => setErrorMessage("")}>
          <h5 className="success_title drawal_title">{errorMessage}</h5>
        </Modal>
      )}
    </>
  );
};
export default WithDrawalPage;
